import { reactive, toRefs } from 'vue'
import { Post } from '@/model/data-object/Post'

class AppQuery {
  showFollowers = false
  showSubscribers = false
  showAllReplies = false
  showUnseenReplies = false
  showReportedPosts = false
  showSuperLike = false
  allPosts = false
}

export enum ViewType {
  TOP_NEWEST,
  DISCUSSION,
  PROFILE,
  PROFILE_USER_EDIT,
  PROFILE_EMAIL_EDIT,
  WIDGET_DISABLED,
}

export enum Languages {
  sk = 'sk',
  en = 'en',
}

class AppState {
  initTime = new Date()
  loggingIn = false
  language = Languages.sk
  loadingPosts = false
  loggedIn = false
  loadingTopic = false
  showLastSavedPost = false
  postToShow: Post | null = null
  lastSavedPost: Post | null = null
  userIdToShow: number | null = null
  createSingleDisabled = false
  saveSingleDisabled = false
  profileLoading = false
  topicNotFound = false
  appError: Error | null = null
  viewType = ViewType.DISCUSSION
  query: AppQuery = new AppQuery()
  // watched vars
  postIdToShow: number | null = null
  respondToPostId: number | null = null
  loadingList = false
  firstForumVisit = false
}

const appState = reactive<AppState>(new AppState())

const refreshInitTime = () => {
  appState.initTime = new Date()
}

export default function useAppState() {
  return { ...toRefs(appState), refreshInitTime }
}
